import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full" }, null, -1)
const _hoisted_2 = { class: "flex items-center flex-nowrap justify-between mt-[12px]" }
const _hoisted_3 = { class: "flex flex-nowrap items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ml-[24px] text-[13px] text-Text/text_high" }, "Are you sure?", -1)
const _hoisted_5 = { class: "text-[13px] font-gordita-medium text-Text/text_high" }

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import { IncrediButton } from 'incredi-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'disableStepTwo',
  emits: ["deactivate", "hideDisableStepTwo"],
  setup(__props, { emit }: { emit: ({ (e: 'deactivate'): void; (e: 'hideDisableStepTwo'): void }), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "h-[56px] bg-System/app_white" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_unref(IncrediButton), {
            class: "ml-[12px]",
            design: "primary-red",
            size: "small",
            type: "submit",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('deactivate')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.footer.deactivate')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(IncrediButton), {
          class: "mr-[12px]",
          design: "ghost-grey",
          size: "small",
          type: "submit",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('hideDisableStepTwo')), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('settings.dialogs.connectActiveDirectory.footer.cancel')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})